module.exports = __webpack_public_path__ + "img/boys_of_summer.71e7e57e.jpg";